import { compose } from 'recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import {
  bodyStyleIds,
  pipelineDataByBodyStyleId,
} from 'reducers/seriesPipeline/selectors';
import { mini } from 'reducers/dashboard/selectors';
import { addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { addProps } from 'utils/recompose';
import { bodyStyles } from 'reducers/bodyStyles/selectors';

const mapStateToProps = combineSelectors({
  bodyStyles,
  bodyStyleIds,
  mini,
  pipelineDataByBodyStyleId,
});

export const filteredBodyStyleIds = ({
  bodyStyles,
  bodyStyleIds,
  pipelineDataByBodyStyleId,
}) => {
  const filteredBodyStyleIds = bodyStyleIds.filter(bodyStyleId => {
    const zeroPipelineQuantity = Object.keys(
      pipelineDataByBodyStyleId[bodyStyleId],
    )
      .map(e => pipelineDataByBodyStyleId[bodyStyleId][e])
      .every(el => el.quantity === 0);
    const withBodyStyleDescription = bodyStyles.indexIds.includes(bodyStyleId);
    const shouldBeFiltered = !withBodyStyleDescription && zeroPipelineQuantity;
    return !shouldBeFiltered;
  });
  return filteredBodyStyleIds;
};

export default compose(
  connect(mapStateToProps),
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'dealerInventory',
      'processingCenter',
      'inTransitToVPC',
      'scheduledInProduction',
      'producedNotShipped',
      'onOrder',
      'unsubmitted',
      'projectedPipeline',
      'currentStatusString',
      'recentHistoryFootnote',
    ],
  }),
  addProps({ filteredBodyStyleIds }),
);
